import { EpimsBaseEntityDto } from './epim-base.dto';

export class RequestCategoryDto extends EpimsBaseEntityDto {
  RequestCategoryName: string;
  RequestTypeId: string;
  AccountableFunctionId: string;
  SubscriptionUserId: string;
  }
